<cx-generic-link
  *ngIf="component.data$ | async as data"
  [url]="data.url"
  [target]="getTarget(data)"
  [style]="data.styleAttributes"
  [class]="data.styleClasses">
  <span>{{ data.linkName }}</span>
</cx-generic-link>
